// extracted by mini-css-extract-plugin
export default {"visualCheckbox":"style_visualCheckbox__xJeaE","label":"style_label__AnHoz"};